// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/plus.js';

import { paths } from '../generated/plus';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('plus', Original, paths);
